// extracted by mini-css-extract-plugin
export default {"menu":"G4v259AI7U2BvsF7FamN"};